/**
 * event handling library
 *
 * @author Haithem Bel Haj (hb@dietaikonauten.com)
 */
import { without, extend } from 'lodash';

const hiddenListeners = '__listeners__';

/**
 * trigger event
 *
 * @param target
 * @param type
 * @param data
 * @returns {*}
 */
export function trigger(target, type, data) {

  let cEvent;

  if (document.createEvent) {

    cEvent = document.createEvent('Event');
    cEvent.initEvent(type, true, false);

    extend(cEvent, data);

    return target.dispatchEvent(cEvent);
  }

  cEvent = document.createEventObject();

  extend(cEvent, data);

  return target.fireEvent('on' + type, cEvent);
}

/**
 * add event listner and save a ref in the elem
 *
 * @param el
 * @param event
 * @param listener
 */
export function addListener(el, event, listener) {

  el.addEventListener(event, listener);

  if (!el[hiddenListeners]) {

    el[hiddenListeners] = [];
  }

  el[hiddenListeners].push({ listener, event });
}


/**
 * remove event listner and remove the ref
 *
 * @param el
 * @param event
 * @param listener
 */
export function removeListener(el, event, listener) {

  if (!listener) {

    el[hiddenListeners].filter(el => {

      return el.event === event;
    }).forEach(({ listener }) => {

      return removeListener(el, event, listener);
    });
  }

  el.removeEventListener(event, listener);

  el[hiddenListeners] = without({ event, listener });
}

/**
 * remove all listeners
 *
 * @param el
 */
export function removeListeners(el) {

  if (!el[hiddenListeners]) {

    return;
  }

  el[hiddenListeners].forEach(({ event, listener }) => removeListener(el, event, listener));
}
